var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Buscar","single-line":"","hide-details":"","clearable":"","outlined":"","dense":""},on:{"input":_vm.setSearchTerm}})}
var staticRenderFns = []

export { render, staticRenderFns }